import { useCognitoContext } from '@/context/cognitoClient';
import { useEffect } from 'react';

const TIME_5_MINUTES = 5 * 60 * 1000;

export const useCognito = (options?: { errorHandler?: (arg: string) => void }) => {
  const { _isInitialized, _init, errorMesssage, ...rest } = useCognitoContext();

  useEffect(() => {
    if (!_isInitialized) {
      _init();

      // Set an interval to keep the Cognito data fresh
      // This is a workaround for the Cognito client not updating the data automatically
      //TODO: check if there is a better way to do this
      const intervallID = setInterval(() => {
        _init();
      }, TIME_5_MINUTES);

      return () => {
        clearInterval(intervallID);
      };
    }
  }, [_isInitialized, _init]);

  useEffect(() => {
    if (errorMesssage && options?.errorHandler) {
      options.errorHandler(errorMesssage);
    }
  }, [errorMesssage, options]);

  return { ...rest, errorMesssage };
};
